import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

interface TrustScoreDetails {
  score: number;
  is_verified: boolean;
  pending_reports: number;
  resolved_reports: number;
  active_bans: number;
  historical_bans: number;
  pops_received: number;
  matches_count: number;
  trust_level: "excellent" | "good" | "moderate" | "low" | "poor";
}

export const useTrustScore = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getTrustScore = useCallback(async (userId: string): Promise<number | null> => {
    try {
      const { data, error } = await supabase.rpc("calculate_user_trust_score", {
        _user_id: userId,
      });

      if (error) throw error;
      return data;
    } catch (err) {
      console.error("Error getting trust score:", err);
      return null;
    }
  }, []);

  const getTrustScoreDetails = useCallback(async (userId: string): Promise<TrustScoreDetails | null> => {
    setLoading(true);
    setError(null);
    try {
      const { data, error } = await supabase.rpc("get_user_trust_score_details", {
        _user_id: userId,
      });

      if (error) throw error;
      return data as unknown as TrustScoreDetails;
    } catch (err: any) {
      console.error("Error getting trust score details:", err);
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getTrustScore,
    getTrustScoreDetails,
    loading,
    error,
  };
};
